module.exports = __webpack_public_path__ + "static/media/ignition-on.05f727cd.svg";